// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layer-legend-component {\n    padding: 5px;\n}\n\n.map-legend-layer-title {\n    font-weight: 600;\n}\n\n.map-legend-color-rectangle {\n    width: 15px;\n    height: 15px;\n    margin: 3px;\n    background: gray;\n    display: block;\n}\n\n.map-legend-color-text {\n    position: relative;\n    margin-left: 10px;\n}\n\n.layer-editor-type-image {\n    /* width: 32px !important; */\n    margin: 10px;\n    margin-right:13px;\n    margin-top:15px;\n    cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
